import { type AxiosResponse } from 'axios'
import { baseApi } from 'entities/Auth'
import {
  type IBaseSmartCallFlowData,
  type IParamsUpdateInboxWorkflow,
  type IResponseCreateWorkflow,
  type IResponseInboxWorkflow,
} from './types'

class Api {
  getInboxWorkflow(id: number): Promise<AxiosResponse<IResponseInboxWorkflow>> {
    return baseApi.get(`/teams/${id}/workflow`)
  }

  createInboxWorkflow(
    id: number,
    params: IParamsUpdateInboxWorkflow
  ): Promise<AxiosResponse<IResponseInboxWorkflow>> {
    return baseApi.post(`/teams/${id}/workflow`, params)
  }

  updateInboxWorkflow(
    id: number,
    params: IParamsUpdateInboxWorkflow
  ): Promise<AxiosResponse<IResponseInboxWorkflow>> {
    return baseApi.put(`/teams/${id}/workflow`, params)
  }
  removeInboxWorkflow(id: number): Promise<AxiosResponse> {
    return baseApi.delete(`/teams/${id}/workflow`)
  }

  createWorkflow(payload: IBaseSmartCallFlowData): Promise<AxiosResponse<IResponseCreateWorkflow>> {
    return baseApi.post('workflows/workflows', {
      ...payload,
      source_type: 'voice',
      settings: { disable_cancel_check: true },
    })
  }
  updateWorkflow(
    id: string,
    payload: IBaseSmartCallFlowData
  ): Promise<AxiosResponse<IResponseCreateWorkflow>> {
    return baseApi.post(`workflows/workflows/${id}`, payload)
  }
  enableWorkflow(id: string): Promise<AxiosResponse> {
    return baseApi.post(`workflows/workflows/${id}/enable`)
  }
}

export const SmartCallApi = new Api()
